import type { SxProps } from "@mui/material";

// Panel
export const panelStyle: SxProps = {
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  bottom: 0,
  minHeight: 100,
  height: 280,
  background: "var(--bg-color)",
  borderTop: "1px solid #ccc",
};

export const panelPinStyle: SxProps = {
  height: 15,
  lineHeight: 1,
  cursor: "row-resize",
  textAlign: "center",
};
